import { InternalChromeConfig } from '@amzn/aac-chrome-internal-api';
import { ATC_EXTERNAL_TOGGLE } from 'src/commons/constants';

/**
 * Pure predicate. `isInternalView` is passed in rather than read from
 * InternalChromeConfigContext here: this used to call
 * useInternalChromeConfigContext(), which made an innocuous-looking util into a
 * hook and let both callers invoke it conditionally, breaking hook ordering.
 */
export const canShowSalesAssistant = (
  userEmail: string,
  isInternalView: boolean | undefined,
): boolean => {
  const isInternalAndNotToggledExternal: boolean =
    !!isInternalView &&
    !(window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) == 'true');

  const isAmazonEmail = userEmail.toLowerCase().includes('amazon.');

  return isInternalAndNotToggledExternal && isAmazonEmail;
};

export const createMountProps = (
  amazonAlias: string,
  userName: string,
  // Only `config.applicationName` is read here. Typed as a partial config so it
  // accepts both the full InternalChromeConfigContext state passed in
  // production and the `{ config: {} }` / `{ config: { applicationName } }`
  // mocks the unit tests pass.
  chromeConfigContext: { config: Partial<InternalChromeConfig> },
) => {
  const applicationName =
    chromeConfigContext.config.applicationName || 'unknown';
  return {
    userAlias: amazonAlias,
    userName: userName,
    window: window.location.host,
    applicationName: applicationName,
  };
};
